import { Badge, BoxIcon, GlobeIcon, Icon, ShopIcon } from "evergreen-ui";

// Single source of truth for the static order tag badges: short label, the
// Romanian hover tooltip, and presentation (color / icon). Edit here — both
// the order-list badges (ComponentBlocks) and the dashboard legend
// (DashboardInstructions) read from this one map, so they never drift.
//
// Do-not-deliver tags (TROLL / OGRE / custom) are NOT here — those live in the
// DB and are managed from the v2 "Lista neagra livrare" page; their tooltip is
// each tag's own `description`.
export const ORDER_TAGS = {
  PREORDER: {
    label: "P",
    tooltip: "Precomanda — comanda contine produse in precomanda.",
    style: { backgroundColor: "#9b5cac", color: "white" },
  },
  BACKORDER: {
    label: "CF",
    tooltip:
      "Comanda furnizor — necesita notificarea grupului pentru comanda produsului.",
    style: { backgroundColor: "#ff914d", color: "white" },
  },
  SINGLES: {
    label: "S",
    tooltip: "Singles — comanda contine carti single.",
    style: { backgroundColor: "#00af99", color: "white" },
  },
  STORE_PL: {
    label: "PL",
    tooltip: "Ridicare personala din magazinul Ploiesti.",
    style: { backgroundColor: "#ffde59", color: "#333" },
    icon: ShopIcon,
  },
  STORE_BV: {
    label: "BV",
    tooltip: "Ridicare personala din magazinul Brasov.",
    style: { backgroundColor: "#3dc2ff", color: "white" },
    icon: ShopIcon,
  },
  LOCKER: {
    label: "EB",
    tooltip: "Easybox — livrare la locker Sameday.",
    icon: BoxIcon,
    iconColor: "red",
  },
  B2B: {
    label: "B2B",
    tooltip: "Client persoana juridica (firma).",
    color: "red",
  },
  EXTERNAL: {
    label: "INT",
    tooltip: "Comanda externa — livrare in afara Romaniei (DPD international).",
    style: { backgroundColor: "#0ea5e9", color: "white" },
    icon: GlobeIcon,
  },
};

// Render order for the dashboard legend.
export const ORDER_TAG_ORDER = [
  "STORE_PL",
  "STORE_BV",
  "LOCKER",
  "SINGLES",
  "PREORDER",
  "BACKORDER",
  "B2B",
  "EXTERNAL",
];

/**
 * Render the badge for a tag key. `label` overrides the default short label
 * (the singles badge passes a dynamic count, e.g. "S7"). Tooltip wrapping is
 * the caller's job so the same badge can be used with or without a Tooltip.
 */
export const renderOrderTagBadge = (key, { label } = {}) => {
  const tag = ORDER_TAGS[key];
  if (!tag) return null;
  return (
    <Badge style={tag.style} color={tag.color}>
      {tag.icon && (
        <Icon icon={tag.icon} size={12} marginRight={5} color={tag.iconColor} />
      )}
      {label != null ? label : tag.label}
    </Badge>
  );
};
